export default __webpack_public_path__ + "static/media/warning.78029343.svg";